import { render } from "./collections-section.vue?vue&type=template&id=dfeaaf42"
import script from "./collections-section.vue?vue&type=script&lang=js"
export * from "./collections-section.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__